import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=050ad85c&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=ts&"
export * from "./DataTable.vue?vue&type=script&lang=ts&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=050ad85c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ad85c",
  null
  
)

export default component.exports